import React, { Component } from 'react';

class H3Subtitle extends Component {
    render() {
        return (
            <React.Fragment>
                 <h3 className={'page-subtitle ' +  this.props.titleClass} tabIndex="0">{ this.props.titleText }</h3>
            </React.Fragment>
        );
    }
}

export default H3Subtitle;